export { default } from './banner'
export type { Props as BannerProps } from './banner'
